<div class="dialog-header">
  <h2 class="dialog-header__title">
    {{ "feedbackPage.title" | translate }}
  </h2>

  <button
    type="button"
    mat-icon-button
    (click)="close()"
  >
    <mat-icon svgIcon="close" />
  </button>

  @if (isLoading$ | async) {
    <mat-progress-bar
      mode="indeterminate"
      class="spinner"
    />
  }
</div>

<div class="expansion-panels-section">
  <pu-expansion-panel
    #panel="pu-expansion-panel"
    class="profile-expansion-panel"
    hideToggle
    isTogglableByHeader
    [opened]="true"
  >
    <div class="expansion-panel-header">
      <mat-icon
        class="profile-icon"
        svgIcon="users"
      />

      <span>{{ "feedbackPage.profile.title" | translate }}</span>

      <mat-icon
        class="expand-icon"
        [class.expand-icon__rotated]="panel.expanded"
        svgIcon="chevron-down"
      />
    </div>

    <ng-template puExpansionPanelContent>
      @if (profile$ | async; as profile) {
        <ca-bot-user-profile [profile]="profile" />
      }
    </ng-template>
  </pu-expansion-panel>

  <pu-expansion-panel
    #chatPanel="pu-expansion-panel"
    class="chat-expansion-panel"
    hideToggle
    isTogglableByHeader
    [opened]="true"
  >
    <div class="expansion-panel-header">
      <mat-icon
        class="chat-icon"
        svgIcon="message-chat-square"
      />

      <span>{{ "feedbackPage.feedback.title" | translate }}</span>

      <mat-icon
        class="expand-icon"
        [class.expand-icon__rotated]="chatPanel.expanded"
        svgIcon="chevron-down"
      />
    </div>

    <ng-template puExpansionPanelContent>
      @if (feedback$ | async; as feedback) {
        <ca-chat
          class="chat"
          [messages]="feedback.items"
        />
      }
    </ng-template>
  </pu-expansion-panel>
</div>

<div class="send-message-section">
  @if (feedback?.status !== FeedbackStatus.Processed) {
    <form [formGroup]="form" class="text-block">
      <pu-uploader
        formControlName="images"
        apiS3="/settings/upload/image/"
        preSignedUrlKey="presignedUrl"
        accept=".jpg,.jpeg,.png,.heic"
        multiple
        hiddenPlaceholder
      />

      <div>
        <ca-rich-text-editor
          formControlName="text"
          [toolbarButtons]="editorButtons"
          [editorOptions]="editorOptions"
        />

        @if (form.controls.text.hasError('required') && !form.controls.text.untouched) {
          <mat-error class="mat-error">
            {{ "validationErrors.required" | translate }}
          </mat-error>
        }
      </div>
    </form>
  }

  <div class="dialog-actions">
    @if (feedback?.status !== FeedbackStatus.Processed) {
      <button
        type="button"
        mat-flat-button
        class="action-btn"
        [disabled]="(isLoading$ | async) || form.invalid"
        (click)="onSendFeedback()"
      >
        {{ "feedbackPage.action.send" | translate }}
      </button>
    }
    <button
      type="button"
      mat-stroked-button
      class="action-btn"
      [disabled]="isLoading$ | async"
      (click)="close()"
    >
      {{ "feedbackPage.action.close" | translate }}
    </button>
  </div>
</div>
